import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { validCnpj } from '../../../_helpers/CnpjValidate.helper'
import { validEmail } from '../../../_helpers/EmailValidate.helper'
import { validDate } from '../../../_helpers/DateValidate.helper'

import { settingsActions } from '../../../_actions';
import { Input } from '../../../_components';

class Company extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      submitted: false,
      cnpjInvalid: false,
      emailInvalid: false,
      dateInvalid: false,
      maskPhone: '(99) 9999-99999'
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps() {
    const { companyData } = this.props;
    const { submitted } = this.state;

    if (companyData && !submitted) {
      this.setState({
        document: companyData.document.number,
        municipalRegistration: companyData.inscricao_municipal,
        corporateName: companyData.razao_social,
        email: companyData.email,
        address: companyData.endereco,
        addressNumber: companyData.numero,
        neighborhood: companyData.bairro,
        zipCode: companyData.zip_code,
        city: companyData.cidade,
        uf: companyData.uf,
        country: companyData.country,
        phone: companyData.telefone,
        foundationDate: companyData.dt_birthday
      });
    }
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name === 'phone') {
      value = value.replace(/[^\d]+/g,'');

      if (value.length === 11) {
        this.setState({maskPhone: '(99) 99999-9999'});
      } else {
        this.setState({maskPhone: '(99) 9999-99999'});
      }
    } 

    this.setState({[name]: value, cnpjInvalid: false, emailInvalid: false});
  }

  handleSubmit(e) {
    e.preventDefault();

    const { document, corporateName, municipalRegistration, email, address, addressNumber, 
      neighborhood, zipCode, city, uf, country, phone, foundationDate } = this.state;
    const { dispatch, companyUuid, actionType } = this.props;
    
    const documentValid = validCnpj(document);
    const emailValid = validEmail(email);
    const dateValid = validDate(foundationDate);

    this.setState({submitting: true})

    !documentValid ?
      this.setState({cnpjInvalid: true}) :
      this.setState({cnpjInvalid: false})

    !emailValid ?
      this.setState({emailInvalid: true}) :
      this.setState({emailInvalid: false})
    
    !dateValid ?
      this.setState({dateInvalid: true}) :
      this.setState({dateInvalid: false})

    if (!corporateName || !documentValid || !municipalRegistration || !emailValid || !address || !addressNumber || !neighborhood || !zipCode || !city || !uf || !country || !phone || !dateValid) 
      return this.setState({submitting: false, submitted: true});

    let obj = {
      "company": {
        "document": {
          "type": "cnpj",
          "number": document
        },
        "inscricao_municipal": municipalRegistration,
        "razao_social": corporateName,
        "email": email,
        "endereco": address,
        "numero": addressNumber,
        "bairro": neighborhood,
        "zip_code": zipCode,
        "cidade": city,
        "uf": uf,
        "country": country,
        "telefone": phone,
        "dt_birthday": foundationDate,
        "dt_payment": null,
        "type_payment": null,
        "credit_card": null,
        "notes": null
      }
    }

    if (actionType === 'view')
      return false

    dispatch(settingsActions.createCompany(companyUuid, obj))
    .then(res => {

      if ( res.type !== "CREATE_COMPANY_FAILURE" && res.type !== "UPDATE_COMPANY_FAILURE" ) {
        this.setState({submitting: false, submitted: true});

        this.props.onCreate();

        return toast.error(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-success'
        });
      }

      this.setState({submitting: false, submitted: false})

      return toast.error(res.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-error'
      });
    })
  }

  render() {
    const { submitted, submitting, cnpjInvalid, document, corporateName, municipalRegistration, 
      email, address, addressNumber, neighborhood, zipCode, city, uf, country, phone, foundationDate, maskPhone, emailInvalid, dateInvalid } = this.state;
    const { actionType } = this.props;
    
    let title;
    let button;
    let buttonLoading;
    let readOnly;

    switch (actionType) {
      case 'edit':
        title = 'Editar empresa'
        button = 'Editar'
        buttonLoading = 'Editando...'
        break;
      case 'view':
        title = 'Visualizar empresa'
        readOnly = true
        break;
      default:
        title = 'Adicionar empresa'
        button = 'Adicionar'
        buttonLoading = 'Adicionando...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="title">{title}</p>
              {
                actionType === 'view' ?
                <p className="disclaimer">Abaixo você pode visualizar as informações da empresa.</p> :
                <p className="disclaimer">Preencha os campos abaixo com as informações da empresa.</p>
              }
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="lnr lnr-cross"></i>
              </button>
              <form action="#" className="form" id="companyForm" method="POST" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  <Input 
                    mask="99.999.999/9999-99" 
                    label="CNPJ" 
                    type="text" 
                    hasChanged={this.handleChange} 
                    name="document" 
                    submitted={submitted} 
                    property={document} 
                    onError="Preencha o CNPJ"
                    onInvalid="Insira um CNPJ válido"
                    invalid={cnpjInvalid}
                    readOnly={readOnly}
                  />
                  <Input
                    label="Incrição municipal"
                    type="text"
                    name="municipalRegistration"
                    property={municipalRegistration}
                    hasChanged={this.handleChange}
                    onError="Preencha a incrição municipal"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Razão Social"
                    type="text"
                    name="corporateName"
                    submitted={submitted}
                    property={corporateName}
                    hasChanged={this.handleChange}
                    onError="Preencha a razão social"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Email"
                    type="text"
                    name="email"
                    submitted={submitted}
                    property={email}
                    hasChanged={this.handleChange}
                    onError="Preencha o email"
                    onInvalid="Insira um email válido"
                    readOnly={readOnly}
                    invalid={emailInvalid}
                  />
                  <Input
                    label="Endereço"
                    type="text"
                    name="address"
                    submitted={submitted}
                    property={address}
                    hasChanged={this.handleChange}
                    onError="Preencha o endereço"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Número do endereço"
                    type="text"
                    name="addressNumber"
                    submitted={submitted}
                    property={addressNumber}
                    hasChanged={this.handleChange}
                    onError="Preencha o número do endereço"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Bairro"
                    type="text"
                    name="neighborhood"
                    property={neighborhood}
                    hasChanged={this.handleChange}
                    onError="Preencha o bairro"
                    readOnly={readOnly}
                  />
                  <Input
                    mask="99999-999"
                    label="CEP"
                    type="text"
                    name="zipCode"
                    submitted={submitted}
                    property={zipCode}
                    hasChanged={this.handleChange}
                    onError="Preencha o CEP"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Cidade"
                    type="text"
                    name="city"
                    submitted={submitted}
                    property={city}
                    hasChanged={this.handleChange}
                    onError="Preencha o cidade"
                    readOnly={readOnly}
                  />
                  <Input
                    label="Estado"
                    type="text"
                    name="uf"
                    submitted={submitted}
                    property={uf}
                    hasChanged={this.handleChange}
                    onError="Preencha o estado"
                    readOnly={readOnly}
                  />
                  <Input
                    label="País"
                    type="text"
                    name="country"
                    submitted={submitted}
                    property={country}
                    hasChanged={this.handleChange}
                    onError="Preencha o país"
                    readOnly={readOnly}
                  />
                  <Input
                    mask={maskPhone}
                    label="Telefone"
                    type="text"
                    name="phone"
                    submitted={submitted}
                    property={phone}
                    hasChanged={this.handleChange}
                    onError="Preencha o telefone"
                    readOnly={readOnly}
                  />
                  <Input
                    mask="99/99/9999"
                    label="Data de fundação"
                    type="text"
                    name="foundationDate"
                    property={foundationDate}
                    hasChanged={this.handleChange}
                    onError="Preencha a data de fundação"
                    onInvalid="Insira uma data válida"
                    readOnly={readOnly}
                    invalid={dateInvalid}
                  />
                </div>
                {
                  submitting ?
                    <button type="button" className="btn btn-blue float-right disabled" disabled>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="sr-only"> {buttonLoading}</span>
                    </button>    
                  : actionType === 'view' ?
                    <button type="submit" className="btn btn-blue float-right" data-dismiss="modal">OK</button> :
                    <button type="submit" className="btn btn-blue float-right">{button}</button>
                }
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { companyStatus } = state;
  return companyStatus;
}

const ConnectedCompanyModal = connect(mapStateToProps)(Company);
export { ConnectedCompanyModal as Company }